import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { useAuth } from '../App';

const BrandLink = ({ className = "" }) => {
  const { user } = useAuth();
  
  // Determine navigation destination based on user role
  const getDestination = () => {
    if (!user) return "/";
    if (user.role === "professional") return "/professional";
    if (user.role === "individual") return "/individual";
    return "/";
  };

  return (
    <Link 
      to={getDestination()} 
      className={`flex items-center space-x-2 hover:opacity-80 transition-opacity ${className}`}
    >
      <TrendingUp className="w-8 h-8 text-blue-600" />
      <span className="text-xl font-bold text-gray-900">Finance Vitals</span>
    </Link>
  );
};

export default BrandLink;